import Modal from '@paycor/modal';
import { useTranslation } from 'react-i18next';
import style from './style.module.scss';
import Button from '@paycor/picl/button';

export const IntegrationConsiderationsModal = ({ showModal, handleShowModal, handleAPI }) => {
	const { t } = useTranslation();
	const modalTitle = `${t('Integration_Considerations', 'Integration Considerations')}`;

	const ModalBody = () => {
		return (
			<>
				<div className={style.modal_body}>
					<div className={style.Integration_description}>
						<div>
							{t(
								'You_May_Have_Integration_Patners_That_Requires_Specific_Employee_Number',
								'You may have integration partners that require specific employee number formatting. Please ensure that any changes made to the formatting options comply with these requirements.'
							)}
						</div>
						<div>{t('Do_You_Want_To-Proceed', 'Do you want to proceed?')}</div>
					</div>
				</div>
			</>
		);
	};

	const BasicFooter = () => (
		<div className={style.basic_footer}>
			<Button type={Button.Types.SECONDARY} onClick={() => handleShowModal(false)}>
				{t('No', 'No')}
			</Button>

			<Button
				type={Button.Types.PRIMARY}
				onClick={() => {
					handleShowModal(false);
					handleAPI();
				}}
			>
				{t('Yes_Proceed', 'Yes, Proceed')}
			</Button>
		</div>
	);

	return (
		<Modal
			show={showModal}
			customModalClass={style.customModal}
			popupWidth="700px"
			body={<ModalBody />}
			size={Modal.Sizes.DEFAULT}
			title={modalTitle}
			footer={<BasicFooter />}
			onClose={() => handleShowModal(false)}
			footerStyle={Modal.Footer.DARK}
			backdrop
		/>
	);
};
